import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { sortOptions } from '../selector-editor-utils';
import type { QuestionNodeData } from './canvas-types';
import styles from './question-node.module.css';

export const QuestionNode = memo(({ data, selected }: NodeProps) => {
  const { prompt, options, isRoot } = data as QuestionNodeData;
  const sorted = sortOptions(options);

  return (
    <div className={`${styles.node} ${selected ? styles.selected : ''} ${isRoot ? styles.root : ''}`}>
      <Handle type="target" position={Position.Top} className={styles.targetHandle} />

      <div className={styles.header}>
        <span className={styles.prompt}>
          {prompt.length > 50 ? `${prompt.slice(0, 50)}...` : prompt}
        </span>
        {isRoot && <span className={styles.rootBadge}>Start</span>}
      </div>

      <div className={styles.options}>
        {sorted.map((option) => (
          <div key={option.id} className={styles.optionRow}>
            <span className={styles.optionLabel}>
              {option.label || 'Untitled'}
            </span>
            <Handle
              type="source"
              position={Position.Right}
              id={option.id}
              className={styles.sourceHandle}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

QuestionNode.displayName = 'QuestionNode';
